import React from "react"
import {Typography} from "@mui/material"
import styled from "styled-components"

import {AccountDetail} from "@indebted/api"

// CustomFieldsList renders the client-defined values recorded on an account.
//
// Values are shown exactly as the client's file carried them — a date reads as
// they wrote it, a boolean reads "true" — so an agent quoting one back to a
// client is quoting what the client's own system holds.
//
// The label/value pairing matches the account details above it, since these are
// account attributes too; only their origin differs.
function CustomFieldsList({
	customFields,
	recordedAt,
	formVersion,
}: {
	customFields: AccountDetail[]
	recordedAt?: string
	formVersion?: string
}) {
	return (
		<>
			{customFields.map(({Label, Value}) => (
				<Field key={Label}>
					<Typography variant="caption" color="textSecondary" display="block">
						{Label}
					</Typography>
					<Typography variant="body2" display="block">
						{Value}
					</Typography>
				</Field>
			))}
			{recordedAt && (
				<Provenance>
					<Typography variant="caption" color="textSecondary" display="block">
						Recorded {recordedAt}
						{formVersion && ` · form version ${formVersion}`}
					</Typography>
				</Provenance>
			)}
		</>
	)
}

const Field = styled.div`
	padding: 8px 0;

	& + & {
		border-top: 1px solid rgba(0, 0, 0, 0.12);
	}
`

// Separated from the fields rather than listed as one: it describes the set,
// not a value in it.
const Provenance = styled.div`
	margin-top: 8px;
	padding-top: 8px;
	border-top: 1px solid rgba(0, 0, 0, 0.12);
`

export {CustomFieldsList}
